/**
 * SmithAppHeader — Iter256
 *
 * Drop-in wrapper around `AppHeader` that AUTO-INJECTS the standard
 * MVP toolbar (Claire · Last update · Dark · PT/EN · Refresh · Bell ·
 * User pill) AFTER each page's own children, and adds the same actions
 * to the mobile kebab menu.
 *
 * Each Smith Protective screen just replaces
 *   `import AppHeader from "../../components/AppHeader";`
 * with
 *   `import AppHeader from "../../components/SmithAppHeader";`
 * and keeps its existing `<AppHeader ...>` markup. No other edits
 * required — the standard actions are appended automatically.
 *
 * Extra props (all optional; forwarded from the page):
 *   • claireQuestion — string question the Claire widget pre-fills
 *   • lastUpdated    — Date shown next to the clock icon
 *   • onRefresh      — click handler for the standard Refresh button
 *                       (page-specific refreshes can still live in
 *                       `children` — this one is the extra top-right)
 *   • refreshing     — bool spinner state for the standard Refresh btn
 *   • notifCount     — number badge on the bell (0 hides)
 *   • onNotifClick   — click handler for the bell
 *
 * Every other AppHeader prop (title, subtitle, logo, testid, children,
 * mobileVisible, mobileMenu, rightGap, zIndex) is forwarded verbatim.
 */
import AppHeader from "./AppHeader";
import SmithHeaderActions, { SmithHeaderActionsMobile } from "./SmithHeaderActions";


export default function SmithAppHeader({
  // Standard-actions props
  claireQuestion,
  lastUpdated,
  onRefresh,
  refreshing,
  notifCount,
  onNotifClick,
  // AppHeader passthrough
  children,
  mobileMenu,
  testid = "smith-app-header",
  ...rest
}) {
  const stdProps = {
    claireQuestion,
    lastUpdated,
    onRefresh,
    refreshing,
    notifCount,
    onNotifClick,
    testidPrefix: testid,
  };

  return (
    <AppHeader
      testid={testid}
      mobileMenu={<>
        {mobileMenu}
        <SmithHeaderActionsMobile {...stdProps} />
      </>}
      {...rest}
    >
      {children}
      <SmithHeaderActions {...stdProps} />
    </AppHeader>
  );
}
